import React, { useEffect, useState } from 'react';
import config from '~/config';
import { getDatasourcesStatuses } from '~/libs/infrastructure/api/datasourcesStatuses';
import { Detail } from './src/components/Detail';
import { SpinningLoadingIcon } from '~/libs/ui/atoms/SpinningLoadingIcon';
import { CurrentDataSourceStatusResponse } from 'com.cogvio.pricemonitor.api';

export function DataSourcesPage() {
	const [error, setError] = useState(false);
	const [loading, setLoading] = useState(true);
	const [statuses, setStatuses] = useState<CurrentDataSourceStatusResponse[]>([]);

	useEffect(() => {
		getDatasourcesStatuses()
			.then((data) => {
				setStatuses(data.items.flat());
				setLoading(false);
			})
			.catch(() => {
				setError(true);
				setLoading(false);
			});
	}, []);

	return (
		<div className='w-full min-h-full bg-white'>
			<div className='lg:px-10 px-5 pt-4 pb-6 bg-cBlue-50 border-b border-gray-200'>
				<div className='mx-auto max-w-4xl'>
					<h2 className='lg:text-perex text-xl font-display font-semibold text-cPurple-800 tracking-wide'>
						Datasources status
					</h2>
					<p className='mt-1 max-w-2xl text-md leading-normal text-gray-800 tracking-wide'>
						This dashboard provides information about the last update of datasources integrated with the COGVIO Price
						monitor. For additional information or to report a&nbsp;problem, please contact{' '}
						<a href={`mailto:${config.support.email}`} className='underline underline-offset-2 text-cPurple-600'>
							{config.support.email}
						</a>
						.
					</p>
					<p className='mt-3 max-w-2xl text-md leading-normal text-gray-800 tracking-wide'>
						Cogvio is transparently providing the same data as in the source and is not liable for the data complexity,
						accuracy and quality obtained from third parties.
					</p>
				</div>
			</div>
			<div className='lg:px-10 px-5 py-5'>
				{error && (
					<div className='mx-auto max-w-4xl'>
						<div className='w-full h-auto px-3 py-2 rounded-md font-semibold text-md text-red-800 bg-red-100 bg-opacity-90 z-20'>
							Application error, please try refreshing the page. If the error persists, please contact us via email
							&nbsp;
							<a
								href='mailto:support@cogvio.com'
								className='font-semibold underline underline-offset-2 text-red-500 transition hover:text-red-800 hover:underline'
							>
								support@cogvio.com
							</a>
						</div>
					</div>
				)}
				<div className='mx-auto max-w-4xl'>
					{loading && (
						<div className='w-full py-10 flex justify-center items-center'>
							<div className='h-12'>
								<SpinningLoadingIcon />
							</div>
						</div>
					)}

					{!loading && !error && (
						<>
							<h2 className='mb-2 text-lg font-normal text-gray-800 tracking-wide'>
								Price Monitor extracts data from the following data sources:
							</h2>
							<div className='divide-y divide-gray-100 -mx-3'>
								{statuses
									? statuses.map((status) => (
											<Detail key={`${status.dataSource?.country.alpha2}-${status.dataSource?.type}`} status={status} />
									  ))
									: null}
							</div>
						</>
					)}
				</div>
			</div>
		</div>
	);
}
